import { getFromServerToken, patchToServerToken, postToServerToken } from './fetch'
import { useState, useContext } from 'react';
import EventContext from "../store/event-context";

const useListParticipant = () => {
    const [isLoadingParticipants, setIsLoading] = useState(false);
    const [participantsData, setData] = useState();
    const [participantsServerError, setServerError] = useState(null);
    const [participantsMessage, setParticipantMessage] = useState("");
    const eventctx = useContext(EventContext);

    const displayCapnr = (capNr) => {
        let result = capNr;
        // console.log("displayCapnr - Capnr: ", capNr, " - Event",eventctx.event)
        if (eventctx.event && eventctx.event.colors.length === 1) {
            const hlpArray = capNr.split(":");
            result = hlpArray[1];
        }
        return result;
    }

    const updateData = (updated) => {
        console.log("UPDATING")

        const newdata = [...participantsData]
        console.log("updateData - newdata: ", newdata);
        console.log("updateData - updated: ", updated);
        setData(newdata.map(item => {
            // Updated data comes from the response and does not have the participantId property!
            if (item.participantId === updated.id || (updated.participantId && item.participantId === updated.participantId)) {
                item.capnr = updated.capnr;
                item.displayCapnr = displayCapnr(updated.capnr);
                item.state = updated.state;
                item.distance = updated.distance;
                item.birthday = updated.birthday;
                item.age = updated.age;
                item.firstName = updated.firstName;
                item.lastName = updated.lastName;
                item.fullName = updated.firstName + " " + updated.lastName;
                item.zipcode = updated.zipcode;
                item.houseNumber = updated.houseNumber;
                item.teamName = updated.teamName;
                item.wave = updated.wave;
                item.email = updated.email;
                item.iceFirstName = updated.iceFirstName;
                item.iceLastName = updated.iceLastName;
                item.icePhone1 = updated.icePhone1;
                item.icePhone2 = updated.icePhone2;
                item.phone = updated.phone;
                item.changedBy = updated.changedBy;
            }
            return item
        }))
    }

    const updateByActor = (updated) => {
        console.log("UPDATING by Actor - ParticipantsData: ", participantsData);
        const newdata = [...participantsData]
        console.log("old data: ", newdata)
        console.log("updates: ", updated)
        let tmpData = newdata.map(item => {
            // Updated data comes from the response and does not have the participantId property!
            if (item.participantId === updated.id || (updated.participantId && item.participantId === updated.participantId)) {
                item.state = updated.state;
                item.changedBy = updated.changedBy;
            }
            return item
        })
        console.log("New data: ", tmpData);
        setData(tmpData);
    }

    const queryparticipants = async (query) => {
        console.log("Querying data: " + query)
        setIsLoading(true)
        setParticipantMessage("")

        try {
            const { data, status } = await getFromServerToken(`/events/${eventctx.eventId}/participants` + query)

            if (status > 204) {
                console.log("USER ERROR: ")
                setServerError(data.detail)
                setData([])
            }
            else if (status === 204) {
                // Change backend to respond with a 204 if no entries found but no error
                console.log("Status 204 - no entries");
                setData([])
                setServerError("No Match found")
            }
            else {
                console.log("Data result: ", data);
                if ("results" in data && data.results.length) {
                    console.log("Now refreshing")   
                    let tmpData = data.results.map((item, index) => {
                        item.fullName = item.firstName + " " + item.lastName;
                        item.displayCapnr = displayCapnr(item.capnr);
                        item.participantId = item.id;
                        item.id = index;          // New row id
                        return item;
                    });
                    console.log("setData: ", tmpData);
                    setData(tmpData);        
                    //setData(data.results)
                    setServerError('')
                } else {
                    setData([])
                    console.log("Geen data");
                    setServerError("Geen deelnemers gevonden")
                }
            }
        } catch (error) {
            console.log("FETCH ERROR queryparticipants")
            console.log(error)
            setData([])
            setServerError("Network error. Het kan helpen om de pagina te verversen");
        }
        setIsLoading(false);
    }


    const patchParticipant = async (participantId, object_data) => {
        setIsLoading(true)
        setParticipantMessage("")
        try {
            const { data, status } = await patchToServerToken(`/events/${eventctx.eventId}/participants/${participantId}`, JSON.stringify(object_data))

            if (status > 200) {
                console.log("USER ERROR: ")
                setServerError(data.detail)
            }
            else {
                console.log("Now refreshing")
                setServerError('')
                updateData(data)
                console.log(object_data)
                if ("distance" in object_data) { 
                    setParticipantMessage(`afstand van ${data.firstName} is gewijzigd in ${data["distance"]}`)   
                } else if ("capnr" in object_data) {
                    setParticipantMessage(`capnr van ${data.firstName} is gewijzigd in ${data["capnr"]}`)
                    if (object_data.oldCapnr && object_data.reuseCapnr) {
                        reuseCap(object_data["oldCapnr"])
                    }
                }
            }
        } catch (error) {
            console.log("FETCH ERROR patch participant")
            console.log(error)
            setData([])
            setServerError("Error" + JSON.stringify(error));
        }
        setIsLoading(false);
    }

    const registerActor = async (capnr) => {
        setParticipantMessage("")
        setIsLoading(true)
        try {
            console.log("Call registering - capnr: ", capnr);
            const { data, status } = await postToServerToken(`/events/${eventctx.eventId}/actors/${capnr}`, '{"new_state": "registered"}')
            if (status > 200) {
                console.log("USER ERROR: ")
                setServerError(data.detail)
                setData([])
            }
            else {
                // TODO Sync on backend actor state with participant state to make life easier, until then ... do it manually
                setServerError('')
                updateByActor({ ...data, state: "registered" })
            }
        } catch (error) {
            console.log("FETCH ERROR patch participant")
            console.log(error)
            setData([])
            setServerError("Error" + JSON.stringify(error));
        }
        setIsLoading(false);
    }

    const resetParticipant = async (capnr) => {
        setParticipantMessage("")
        setIsLoading(true)
        try {

            const { data, status } = await postToServerToken(`/events/${eventctx.eventId}/actors/${capnr}`, '{"new_state": "reset"}')
            if (status > 200) {
                console.log("USER ERROR: ")
                setServerError(data.detail)
                setData([])
            }
            else {
                // TODO Sync on backend actor state with participant state to make life easier, until then ... do it manually
                setServerError('')
                updateByActor({ ...data, state: "initial" })
            }
        } catch (error) {
            console.log("FETCH ERROR patch participant")
            console.log(error)
            setData([])
            setServerError("Error" + JSON.stringify(error));
        }
        setIsLoading(false);
    }
    const reuseCap = async (capnr) => {
        // Planned to be called as part of another service call so no reset error message of loading
        try {
            const parts = capnr.split(":")
            const color = parts[0]
            const number = parts[1]
            console.log(`Making ${color} ${number} Available again`)
            const { data, status } = await postToServerToken(`/events/${eventctx.eventId}/unassigned/${color}`,  `{"ranges": "${number}", "prefix": ""}`)
            if (status > 200) {
                console.log("USER ERROR on reuse cap: ")
                setServerError(data.detail)
            }
        } catch (error) {
            console.log("FETCH ERROR reuse capnr")
            console.log(error)
            setServerError("Error" + JSON.stringify(error));
        }
    }
    const teamFromList = () => {
        let teamName = "";
        if (participantsData && participantsData.length > 0) {
            for (var i = 0; (i < participantsData.length && teamName.length <= 0); i++ ) {
                if (participantsData[i].teamName && participantsData[i].teamName.length > 0) {
                    teamName = participantsData[i].teamName
                }
            }
        }
        //console.log("teamFromList: ", teamName);
        return teamName;
    }

    return { participantsData, isLoadingParticipants, participantsServerError, queryparticipants, patchParticipant, registerActor, participantsMessage, resetParticipant, teamFromList };
}

export default useListParticipant
